/**
 * Created by mqamhieh on 8/6/17.
 */
(function () {
    var HNotifications = {};
    var container = $("<div class='h-notifications'></div>");
    var nunjucks;
    var $compile;
    var $rootScope;

    var MessagesQueue = new function () {
        var self = this;

        self.add = function (message) {
            container.prepend(message.elm);
            setTimeout(function () {
                var messageHeight = message.elm.height();
                message.elm.height(0);

                setTimeout(function () {
                    message.elm.height(messageHeight);

                    setTimeout(function () {
                        message.elm.removeClass("before");
                    }, 150);
                }, 20);
            }, 1);
        };

    }();

    var Message = function (options) {
        var self = this;
        self.options = {};
        self.options['title'] = options['title'] || "";
        self.options['desc'] = options['desc'] || "";
        self.options['icon'] = options['icon'] || "";
        self.options['type'] = options['type'] || "danger";
        self.options['timeout'] = !isNaN(options['timeout'])? options['timeout']: 3500;
        self.options['onHide'] = options['onHide'];
        self.options['buttons'] = options['buttons'] || [];

        self.hide = function () {
            self.elm.addClass("before-hide");
            self.options['onHide'] && self.options['onHide']();

            setTimeout(function () {
                self.elm.height(0);
                setTimeout(function () {
                    self.elm.remove();
                }, 150);
            }, 300);
        };

        self.elm = $(nunjucks.render("../modules/notifications/views/h_notification_default.html", self.options));

        // Compile the element with AngularJS
        $compile(self.elm)($rootScope);

        self.elm.find("button.h-notification-button").each(function (elmIndex) {
            $(this).on("click", self.options['buttons'][elmIndex]['onClick']);
        });

        self.elm.find(".close-btn").on("click", function () {
            self.hide();
        });

        if (self.options['timeout'] > 0) {
            setTimeout(function () {
                self.hide();
            }, self.options['timeout']);
        }
    };

    HNotifications.show = function(options) {
        var message = new Message(options);
        MessagesQueue.add(message);
        return message;
    };

    HNotifications.init = function (nunjucksWrapper, compile, rootScope) {
        nunjucks = nunjucksWrapper;
        $compile = compile;
        $rootScope = rootScope;
        $("body").append(container);
    };

    window.HNotifications = HNotifications;
})();